module.exports = __webpack_public_path__ + "img/组 126@2x(8)(1).b6db1297.png";